import React from 'react'
import { View } from 'components/View.js'
import TextTitleCondensed from 'components/TextTitleCondensed.js'

/**
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export function ModalTitle ({
  children
}) {
  return (
    <View mx={4}>
      <TextTitleCondensed>
        {children}
      </TextTitleCondensed>
    </View>
  )
}
